export default {
  title: '思政舆情',
  icon: 'rss',
  path: 'http://hngx.gstai.com',
  hideSub: true
}
